import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbSemanticVersionNumberFactory;
/* eslint-disable */
/**
 * AbWeb
 * Core Ab Initio platform services
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/absdk/typescript/target/openapi/openapi//commons/core.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * A semantic version number.
 * @export
 * @interface AbSemanticVersionNumber
 */

export class AbSemanticVersionNumberFactory {}
_AbSemanticVersionNumberFactory = AbSemanticVersionNumberFactory;
_defineProperty(AbSemanticVersionNumberFactory, "FromJSON", function (json) {
  return _AbSemanticVersionNumberFactory.FromJSONTyped(json, false);
});
_defineProperty(AbSemanticVersionNumberFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'major': json['major'],
    'minor': json['minor'],
    'patch': json['patch']
  };
});
_defineProperty(AbSemanticVersionNumberFactory, "ToJSON", function (value) {
  return _AbSemanticVersionNumberFactory.ToJSONTyped(false, value);
});
_defineProperty(AbSemanticVersionNumberFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'major': value.major,
    'minor': value.minor,
    'patch': value.patch
  };
});
//# sourceMappingURL=AbSemanticVersionNumber.js.map
